// Desliza hacia arriba (oculta) con transición de altura/márgenes/padding.
export function slideUp(elm: HTMLElement, duration = 300): Promise<void> {
  if (elm.classList.contains("transitioning")) return Promise.resolve();

  return new Promise<void>((resolve) => {
    elm.classList.add("transitioning");

    // Asegura caja y estado inicial
    elm.style.boxSizing = "border-box";
    elm.style.transitionProperty = "height, margin, padding";
    elm.style.transitionDuration = `${duration}ms`;

    // Fija la altura actual para iniciar la transición
    elm.style.height = `${elm.offsetHeight}px`;
    // Fuerza reflow para que el navegador “registre” la altura previa
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    elm.offsetHeight;

    elm.style.overflow = "hidden";
    elm.style.height = "0";
    elm.style.paddingTop = "0";
    elm.style.paddingBottom = "0";
    elm.style.marginTop = "0";
    elm.style.marginBottom = "0";

    const done = () => {
      elm.style.display = "none";
      elm.style.removeProperty("height");
      elm.style.removeProperty("padding-top");
      elm.style.removeProperty("padding-bottom");
      elm.style.removeProperty("margin-top");
      elm.style.removeProperty("margin-bottom");
      elm.style.removeProperty("overflow");
      elm.style.removeProperty("transition-duration");
      elm.style.removeProperty("transition-property");
      elm.classList.remove("transitioning");
      elm.removeEventListener("transitionend", onEnd);
      resolve();
    };

    const onEnd = (e: TransitionEvent) => {
      // Nos aseguramos de que la transición relevante terminó
      if (e.target === elm && e.propertyName === "height") done();
    };

    elm.addEventListener("transitionend", onEnd, { once: true });
    // Fallback por si no dispara transitionend
    window.setTimeout(done, duration + 50);
  });
}
